import {
    useEffect,
    type FC,
    useRef
} from "react";
import {
    Animated,
    Platform,
    View
} from "react-native";
import type ITraceCaretProps from "./type";
import stylesheet, {
    useStyles
} from "./stylesheet";
import {
    NCoreUIKitTheme
} from "../../../../core/hooks";
import {
    useReducedMotion
} from "../../../../helpers/motion";

const AnimatedView = Platform.OS === "web" ? View : Animated.View;

const TraceCaret: FC<ITraceCaretProps> = ({
    customTheme
}) => {
    const {
        typography,
        durations,
        borders,
        colors
    } = NCoreUIKitTheme.useContext(customTheme);

    const isReduceMotionEnabled = useReducedMotion();

    const isWeb = Platform.OS === "web";

    const opacity = useRef(new Animated.Value(1)).current;

    const {
        webBlink: webBlinkDynamicStyle
    } = useStyles({
        blinkDuration: durations.blink
    });

    useEffect(() => {
        if(isReduceMotionEnabled || isWeb) {
            opacity.setValue(1);

            return;
        }

        const duration = durations.blink / 2;

        const animation = Animated.loop(Animated.sequence([
            Animated.timing(opacity, {
                useNativeDriver: false,
                isInteraction: false,
                duration: 0,
                toValue: 0
            }),
            Animated.delay(duration),
            Animated.timing(opacity, {
                useNativeDriver: false,
                isInteraction: false,
                duration: 0,
                toValue: 1
            }),
            Animated.delay(duration)
        ]));

        animation.start();

        return () => {
            animation.stop();
        };
    }, [
        isReduceMotionEnabled,
        durations.blink,
        opacity,
        isWeb
    ]);

    return <AnimatedView
        style={[
            stylesheet.container,
            {
                height: typography.bodyMediumSize.fontSize,
                backgroundColor: colors.content.text.high,
                width: borders.focus
            },
            isWeb ? !isReduceMotionEnabled && [
                stylesheet.webBlink,
                webBlinkDynamicStyle
            ] : {
                opacity
            }
        ]}
        aria-hidden={true}
    />;
};
export default TraceCaret;
